"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadAddressSchema = exports.CreateAddressSchema = exports.NewAddressSchema = exports.CreateNewAddressSchema = void 0;
const zod_1 = require("zod");
exports.CreateNewAddressSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    isLookup: zod_1.z.boolean(),
    lookup: zod_1.z
        .object({
        googlePlaceAddress: zod_1.z.string(),
        googlePlaceId: zod_1.z.string(),
    })
        .optional(),
    manual: zod_1.z
        .object({
        addressLine1: zod_1.z.string(),
        addressLine2: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        postcode: zod_1.z.string(),
        city: zod_1.z.string(),
        state: zod_1.z.string(),
        country: zod_1.z.string(),
    })
        .optional(),
});
exports.NewAddressSchema = zod_1.z.object({
    id: zod_1.z.string(),
    isLookup: zod_1.z.boolean(),
    lookup: zod_1.z
        .object({
        googlePlaceAddress: zod_1.z.string(),
        googlePlaceId: zod_1.z.string(),
    })
        .optional(),
    manual: zod_1.z
        .object({
        addressLine1: zod_1.z.string(),
        addressLine2: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        postcode: zod_1.z.string(),
        city: zod_1.z.string(),
        state: zod_1.z.string(),
        country: zod_1.z.string(),
    })
        .optional(),
});
const AddressSchema = (idType) => zod_1.z.object({
    id: idType,
    googlePlaceId: zod_1.z.string(),
    googlePlaceAddress: zod_1.z.string(),
});
exports.CreateAddressSchema = AddressSchema(zod_1.z.string().optional());
exports.ReadAddressSchema = AddressSchema(zod_1.z.string());
